export const calculateOffsetFromProductionUsage = (
  solarProduction,
  annualUsage
) => {
  const production = Number(solarProduction);
  const usage = Number(annualUsage);

  if (
    !Number.isFinite(production) ||
    production <= 0 ||
    !Number.isFinite(usage) ||
    usage <= 0
  ) {
    return null;
  }

  return Math.round((production / usage) * 100);
};

export const coalesceNumber = (...values) => {
  for (const value of values) {
    if (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '')
    ) {
      continue;
    }
    const number = Number(value);
    if (Number.isFinite(number)) return number;
  }
  return 0;
};

export const calculateAnnualUsage = (usage, totalUsage = 0) => {
  const values = Array.isArray(usage)
    ? usage
    : typeof usage === 'string'
      ? usage.split(',')
      : [];

  if (values.length) {
    const numericValues = values
      .filter(
        (value) =>
          value !== null &&
          value !== undefined &&
          !(typeof value === 'string' && value.trim() === '')
      )
      .map((value) => Number(value))
      .filter(Number.isFinite);
    if (numericValues.length) {
      return numericValues.reduce((a, b) => a + b, 0);
    }
  }

  const fallback = Number(totalUsage);
  return Number.isFinite(fallback) ? fallback : 0;
};

export const calculateAnnualUsageFromUtility = (utility = {}) => {
  const directTotal =
    utility?.totalUsage ??
    utility?.total_usage ??
    utility?.yearlyUsage ??
    utility?.yearly_usage;
  const averageUsage = utility?.averageUsage ?? utility?.average_usage;
  const averageTotal = Number(averageUsage) * 12;
  const fallback =
    directTotal !== null &&
    directTotal !== undefined &&
    !(typeof directTotal === 'string' && directTotal.trim() === '')
      ? directTotal
      : Number.isFinite(averageTotal)
        ? averageTotal
        : 0;

  return calculateAnnualUsage(utility?.usage, fallback);
};

export const resolveProposalOffset = ({
  solarProduction,
  annualUsage,
  persistedOffset,
  legacyOffset
}) =>
  calculateOffsetFromProductionUsage(solarProduction, annualUsage) ??
  coalesceNumber(persistedOffset, legacyOffset);
